// src/components/common/Toast.jsx
import toast from 'react-hot-toast';

export const success = (msg) => toast.success(msg, { duration: 4000 });
export const error = (msg) => toast.error(msg || 'Something went wrong');
export const info = (msg) => toast(msg, { icon: 'ℹ️' });